import React from 'react';

import BlockingAlert from 'design-system/BlockingAlert';
import IrregularTag from 'design-system/IrregularTag';
import Skeleton from 'design-system/Skeleton';
import PendencyModal from 'design-system/PendencyModal';

import { PENDENCIAS_TEXTS } from '../constants';
import {
  BaseAddress,
  BaseInfo,
  BaseItem,
  BaseList,
  BaseName,
  BaseTexts,
  ModalActionButton,
  PinCircle,
} from './styles';

export type IrregularBase = {
  code: string;
  nickname: string;
  address: string;
  reasons: string[];
};

type IrregularBasesModalProps = {
  open: boolean;
  bases: IrregularBase[];
  isLoading?: boolean;
  onClose: () => void;
  onCallCenter: () => void;
};

const PinIcon = (): JSX.Element => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

const IrregularBasesModal = ({
  open,
  bases,
  isLoading = false,
  onClose,
  onCallCenter,
}: IrregularBasesModalProps): JSX.Element => (
  <PendencyModal
    open={open}
    title={PENDENCIAS_TEXTS.MODAL_BASES_TITLE}
    onClose={onClose}
    width={1065}
  >
    <BlockingAlert>
      {PENDENCIAS_TEXTS.MODAL_BASES_ALERT_PREFIX}
      <strong>{PENDENCIAS_TEXTS.MODAL_BASES_ALERT_STRONG}</strong>
      {PENDENCIAS_TEXTS.MODAL_BASES_ALERT_SUFFIX}
    </BlockingAlert>

    {isLoading && (
      <BaseList>
        <Skeleton height={80} label="Carregando as centrais irregulares" />
        <Skeleton height={80} />
      </BaseList>
    )}

    <BaseList>
      {!isLoading &&
        bases.map((base) => (
          <BaseItem key={base.code}>
            <BaseInfo>
              <PinCircle aria-hidden="true">
                <PinIcon />
              </PinCircle>
              <BaseTexts>
                <BaseName>{base.nickname}</BaseName>
                <BaseAddress>{base.address}</BaseAddress>
                <IrregularTag
                  label={PENDENCIAS_TEXTS.BASE_IRREGULAR_BADGE}
                  reasons={base.reasons}
                />
              </BaseTexts>
            </BaseInfo>

            <ModalActionButton type="button" onClick={onCallCenter}>
              {PENDENCIAS_TEXTS.ACTION_CALL_CENTER}
            </ModalActionButton>
          </BaseItem>
        ))}
    </BaseList>
  </PendencyModal>
);

export default IrregularBasesModal;
